import MessageCenterTypes from './MessageCenterTypes';

export const setMessageCenterModalVisible = (payload) => {
  return {
    type: MessageCenterTypes.SET_OPEN,
    payload,
  };
};
export const setMessageCenterActiveFolderId = (payload) => {
  return {
    type: MessageCenterTypes.SET_ACTIVE_FOLDER_ID,
    payload,
  };
};

export const setMessageCenterActiveMessageId = (payload) => {
  return {
    type: MessageCenterTypes.SET_ACTIVE_MESSAGE_ID,
    payload,
  };
};

export const getMessageCenterFoldersInProgress = (payload) => {
  return {
    type: MessageCenterTypes.GET_FOLDERS_PROGRESS,
    payload,
  };
};
export const getMessageCenterFoldersInSuccess = (payload) => {
  return {
    type: MessageCenterTypes.GET_FOLDERS_SUCCESS,
    payload,
  };
};
export const getMessageCenterFoldersInError = (payload) => {
  return {
    type: MessageCenterTypes.GET_FOLDERS_ERROR,
    payload,
  };
};

export const getMessageListInProgress = (payload) => {
  return {
    type: MessageCenterTypes.GET_MESSAGE_LIST_PROGRESS,
    payload,
  };
};
export const getMessageListInSuccess = (payload) => {
  return {
    type: MessageCenterTypes.GET_MESSAGE_LIST_SUCCESS,
    payload,
  };
};
export const getMessageListInError = (payload) => {
  return {
    type: MessageCenterTypes.GET_MESSAGE_LIST_ERROR,
    payload,
  };
};

export const getMessageDetailsInProgress = (payload) => {
  return {
    type: MessageCenterTypes.GET_MESSAGE_DETAILS_PROGRESS,
    payload,
  };
};
export const getMessageDetailsInSuccess = (payload) => {
  return {
    type: MessageCenterTypes.GET_MESSAGE_DETAILS_SUCCESS,
    payload,
  };
};
export const getMessageDetailsInError = (payload) => {
  return {
    type: MessageCenterTypes.GET_MESSAGE_DETAILS_ERROR,
    payload,
  };
};

export const deleteMessageInProgress = (payload) => {
  return {
    type: MessageCenterTypes.DELETE_MESSAGE_PROGRESS,
    payload,
  };
};
export const deleteMessageInSuccess = (payload) => {
  return {
    type: MessageCenterTypes.DELETE_MESSAGE_SUCCESS,
    payload,
  };
};
export const deleteMessageInError = (payload) => {
  return {
    type: MessageCenterTypes.DELETE_MESSAGE_ERROR,
    payload,
  };
};

export const markAsReadMessageInProgress = (payload) => {
  return {
    type: MessageCenterTypes.MARK_AS_READ_MESSAGE_PROGRESS,
    payload,
  };
};
export const markAsReadMessageInSuccess = (payload) => {
  return {
    type: MessageCenterTypes.MARK_AS_READ_MESSAGE_SUCCESS,
    payload,
  };
};
export const markAsReadMessageInError = (payload) => {
  return {
    type: MessageCenterTypes.MARK_AS_READ_MESSAGE_ERROR,
    payload,
  };
};

export const getComposeEmailIdSearchInProgress = (payload) => {
  return {
    type: MessageCenterTypes.GET_COMPOSE_EMAILS_ID_SEARCH_PROGRESS,
    payload,
  };
};
export const getComposeEmailIdSearchInSuccess = (payload) => {
  return {
    type: MessageCenterTypes.GET_COMPOSE_EMAILS_ID_SEARCH_SUCCESS,
    payload,
  };
};
export const getComposeEmailIdSearchInError = (payload) => {
  return {
    type: MessageCenterTypes.GET_COMPOSE_EMAILS_ID_SEARCH_ERROR,
    payload,
  };
};

export const sendMessageInProgress = (payload) => {
  return {
    type: MessageCenterTypes.SEND_MESSAGE_PROGRESS,
    payload,
  };
};
export const sendMessageInSuccess = (payload) => {
  return {
    type: MessageCenterTypes.SEND_MESSAGE_SUCCESS,
    payload,
  };
};
export const sendMessageInError = (payload) => {
  return {
    type: MessageCenterTypes.SEND_MESSAGE_ERROR,
    payload,
  };
};
